import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Toaster from './components/Toaster';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import VesselAnalysis from './pages/VesselAnalysis';
import LocationAnalysis from './pages/LocationAnalysis';
import FavoritesPage from './pages/FavoritesPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Toaster />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vessel/:vesselId" element={<VesselAnalysis />} />
            <Route path="/location/:locationId" element={<LocationAnalysis />} />
            <Route path="/favorites" element={<FavoritesPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
